import * as moment from 'moment';

import { ClosingReportDto } from './closing-report.dto';

export class ClosingReport {
  public static fromDto(closingReportDto: ClosingReportDto): ClosingReport {
    return new ClosingReport(
      closingReportDto.sequenceNumber,
      moment(closingReportDto.from),
      moment(closingReportDto.to),
      closingReportDto.total,
      closingReportDto.numberOfReceipt
    );
  }

  constructor(
    public sequenceNumber: number,
    public from: moment.Moment,
    public to: moment.Moment,
    public totalRevenue: number,
    public numberOfReceipts: number
  ) {}
}
